import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const BreadCrumb = ({ title, urls }) => {
    return (
        <Box
            sx={{
                backgroundImage: `url('/laptop.jpg')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                padding: 2,
                borderRadius: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '250px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center', // Ensures everything inside is centered
                }}
            >
                <Typography
                    variant="h4"
                    fontWeight="bold"
                    fontSize="2.5rem"
                    sx={{ padding: '1.5rem 0', textAlign: 'center' }}
                >
                    {title}
                </Typography>
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator={
                        <Box
                            sx={{
                                width: '5px',
                                height: '5px',
                                backgroundColor: '#000',
                                transform: 'rotate(45deg)',
                            }}
                        />
                    } // Custom separator
                    sx={{
                        display: 'flex',
                        opacity: 0.9,
                        padding: '8px 16px',
                        borderRadius: 1,
                        justifyContent: 'center', // Centers the breadcrumb items
                    }}
                >
                    {urls.map((url, index) => (
                        <Link
                            key={index}
                            component={RouterLink}
                            to={url.path}
                            underline="hover"
                            color="inherit"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                fontSize: '16px',
                                fontFamily: "'Nunito Sans', sans-serif",
                            }}
                        >
                            {url.label}
                        </Link>
                    ))}
                </Breadcrumbs>
            </Box>
        </Box>

    );
};

export default BreadCrumb;
